/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { useField, useFormikContext } from "formik";

import EditorPR from "../../PrimeReact/EditorPR";

export default function Editor(props) {
  const [field, meta] = useField(props);

  const {
    setFieldValue,
    setFieldTouched,
    validateField,
    touched,
    isSubmitting,
    isValidating,
  } = useFormikContext();

  return (
    <>
      <div>
        <EditorPR
          value={field.value}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          field={field}
          validateField={validateField}
          touched={touched}
          isSubmitting={isSubmitting}
          isValidating={isValidating}
          {...props}
        />
      </div>

      {meta.touched && meta.error ? (
        <small className="p-invalid">{meta.error}</small>
      ) : null}
    </>
  );
}
